module.exports = __webpack_public_path__ + "img/avon-fighting-breast-cancer-02.839fe2e0.jpg";